import { I18n } from 'react-redux-i18n';

import { NewTableColumnAction, NewTableColumnId, NewTableColumnPredefinedActionType, NewTableLoadMetadataFiltering } from "../new-table.types";

export const processColumnActions = (params: { 
  columnActions: Array<NewTableColumnAction>;
  currentContextMenuColumnId?: NewTableColumnId;
  filtering?: NewTableLoadMetadataFiltering;
  openFieldSelector: () => void;
  onColumnRemove: (params?: { columnId?: NewTableColumnId }) => void;
  openFilters: () => void;
  clearFilter: () => void;
}) => {
  const { columnActions, currentContextMenuColumnId, filtering, openFieldSelector, onColumnRemove, openFilters, clearFilter } = params;
  const filteredColumns = Object.keys(filtering?.columns || {});
  const columnFiltered = filteredColumns.some((id) => id === currentContextMenuColumnId);
  const clearFilterAction = { label: I18n.t('Clear Filter'), onClick: clearFilter };
  const withFilters = columnActions.some((x) => x.type === NewTableColumnPredefinedActionType.filters);
  const shouldShowClearFilter = withFilters && columnFiltered && filtering?.filter;
  const processedColumnActions: Array<NewTableColumnAction> = [];

  const predefinedActionsConfig: Record<NewTableColumnPredefinedActionType, { config: NewTableColumnAction }> = {
    [NewTableColumnPredefinedActionType.filters]: { 
      config: { label: I18n.t('Filter'), onClick: openFilters },
    },
    [NewTableColumnPredefinedActionType.addColumn]: { 
      config: { label: I18n.t('Add Column'), onClick: openFieldSelector },
    },
    [NewTableColumnPredefinedActionType.deleteColumn]: { 
      config: { label: I18n.t('Delete Column'), onClick: onColumnRemove },
    },
  };
  
  columnActions.forEach(({ type, ...otherProps }) => {
    if (type && predefinedActionsConfig[type]) {
      const config = {
        ...predefinedActionsConfig[type].config,
        ...otherProps,
      };
      processedColumnActions.push(config);

      if (type === NewTableColumnPredefinedActionType.filters && shouldShowClearFilter) {
        processedColumnActions.push(clearFilterAction);
      }

      return;
    }

    processedColumnActions.push({
      ...otherProps,
      onClick: otherProps.onClick
    });
  });

  return processedColumnActions;
};